import React from 'react';
import MenuSidebar from '@/components/shared/sidebars/MenuSidebars';
import { Icon } from '@/ui/Icon';
import { observer } from 'mobx-react-lite';
import { useToggle } from 'react-use';
import { useTranslation } from 'react-i18next';

interface IProps {
	hasActions: boolean;
}

const MenuButton = observer((props: IProps) => {
	const { hasActions } = props;
	const { t } = useTranslation();
	const [isOpen, setOpen] = useToggle(false);

	const handleClose = () => {
		setOpen(false);
	};

	const handleOpen = () => {
		setOpen(true);
	};

	return (
		<>
			<button
				onClick={handleOpen}
				data-testid="header-button-menu"
				className="size-[calc(24px*var(--font-scale,1))] poin"
				type="button"
				aria-label={isOpen
					? t('accessibility.menuButton.close')
					: t('accessibility.menuButton.open')
				}
				aria-expanded={isOpen}
				aria-controls="menu-sidebar"
				aria-haspopup="dialog"
			>
				<Icon
					name="menu"
					className="size-[calc(24px*var(--font-scale,1))] text-brand-gray-3"
					size={24}
					aria-hidden="true"
				/>
			</button>

			<MenuSidebar
				isOpen={isOpen}
				handleClose={handleClose}
				handleOpen={handleOpen}
				hasActions={hasActions}
				position="right"
				className={'max-w-[400px] !z-20'}
				aria-label={t('accessibility.menuSidebar.label')}
			/>
		</>
	);
});

export { MenuButton };
